import { FC, useMemo } from 'react';

import { GProduct, Variant } from '@/types';
import { useActiveProductBadges } from 'hooks/useActiveProductBadges';
import ProductBadge from '../Product/ProductBadge';

interface IProductBadgesProps {
  product: GProduct;
  weightVariant: Variant;
  onKiosk?: boolean;
}

const ProductBadges: FC<IProductBadgesProps> = ({
  product,
  weightVariant,
  onKiosk,
}) => {
  const { badges, shouldRender } = useActiveProductBadges({
    product,
    weightVariant,
    isDetail: true,
    onKiosk,
  });

  const renderedBadges = useMemo(
    () =>
      badges.map(({ props }, index) => <ProductBadge {...props} key={index} />),
    [badges],
  );

  if (!shouldRender || badges.length === 0) return null;

  return <div className="product__badges">{renderedBadges}</div>;
};

export { ProductBadges };
